import React from 'react';

const Card = ({ icon, title, description, features, content, className = '', children }) => {
  return (
    <div className={`service-card bg-white rounded-xl p-8 glow-card ${className}`}>
      {icon && (
        <div className="text-yellow-500 text-4xl mb-6">
          <i className={icon}></i>
        </div>
      )}
      {title && <h3 className="text-2xl font-bold mb-4">{title}</h3>}
      {description && <p className="text-gray-600 mb-4">{description}</p>}
      {content && <p className="text-gray-600">{content}</p>}
      {features && (
        <ul className="space-y-2">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start">
              <i className="fas fa-check text-yellow-500 mt-1 mr-2"></i>
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      )}
      {children}
    </div>
  );
};

export default Card;